import { getFilenameParts, supportsAudioFormat } from '.';

let audio: HTMLAudioElement;

/**
 * Get the duration of an audio file in seconds
 * @param {File} file a File instance of an audio file
 * @returns {Maybe<number>} the duration in seconds, or null if the audio format is not supported.
 * .aif / .aiff files are only supported in Safari, so they will return null.
 */
export const getAudioDuration = async (file: File): Promise<Maybe<number>> =>
    new Promise(resolve => {
        const { extension } = getFilenameParts(file.name);

        if (!supportsAudioFormat(extension)) {
            resolve(null);
        }

        const reader = new FileReader();

        if (!audio) {
            audio = document.createElement('audio');
        }

        reader.onload = (e: ProgressEvent<FileReader>): void => {
            const source = e?.target?.result;

            if (typeof source === 'string') {
                audio.src = source;

                audio.addEventListener(
                    'loadedmetadata',
                    (): void => {
                        resolve(audio.duration);
                    },
                    false,
                );
            }
        };

        reader.readAsDataURL(file);
    });
